<template lang="html">
  <Row type="flex" justify="center" align="middle" :style="{ width: '100%' }">
    <Col span="24">
      <h1 style="padding-bottom: 16px; text-align: center;" :class="{ red: baseValue < 0, 'table-green': baseValue > 0 }">
        {{ `$${commafy(baseValue)}` }}
      </h1>
      <Table ref="currentRowTable" :columns="columns" :data="formattedTableData"></Table>
    </Col>
  </Row>
</template>

<script>

export default {
  props: {
    tableData: Array,
    baseValue: Number,
  },
  data() {
    return {
      columns: [
        { title: 'Date', key: 'label', width: '3' },
        { title: 'Value', key: 'value', width: '4' },
        { title: 'Growth', key: 'change', width: '3' },
      ],
    };
  },
  methods: {
    commafy(number) {
      return String(number).replace(/(^|[^\w.])(\d{4,})/g, ($0, $1, $2) => $1 + $2.replace(/\d(?=(?:\d\d\d)+(?!\d))/g, '$&,'));
    },
  },
  computed: {
    formattedTableData() {
      const vm = this;

      const fiendlyLabelsMap = {
        'A few seconds ago': 'Today',
        'A month ago': 'Last Month',
        'A year ago': 'Last Year',
      };

      // slice to limit 3 items
      return vm.tableData.slice(0, 3).map((row) => {
        const percentGrowth = ((vm.baseValue - row.value) / vm.baseValue) * 100;
        const indicator = percentGrowth > 0 ? '+' : '';
        return {
          label: fiendlyLabelsMap[row.label] || row.label,
          value: `$${vm.commafy(Number.parseFloat(row.value).toPrecision(9))}`,
          change: row.value ? `${indicator}${Number.parseFloat(percentGrowth).toPrecision(3)}%` : 'No Data',
          cellClassName: {
            change: percentGrowth < 0 ? 'red table-bold' : 'table-green table-bold',
          },
        };
      });
    },
  },
};
</script>

<style lang="css">

.table-green {
  color: #25e8c8;
}
.table-bold {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ChangeIndicatorTable.vue